import Section from "../../layout/Section/Section";
import { testimonials } from "../../../data/testimonials";
import styles from "./Testimonials.module.css";

export default function Testimonials() {
  return (
    <Section
      id="testimonials"
      eyebrow="In their own words"
      title="A better presence. A real difference."
      subtitle="Here’s what business owners have to say about working with us."
      bg="muted"
    >
      <div className={styles.grid}>
        {testimonials.map((testimonial) => (
          <figure key={testimonial.author} className={styles.card}>
            <svg className={styles.quoteMark} viewBox="0 0 32 26" width="32" height="26" fill="currentColor" aria-hidden="true">
              <path d="M0 13C0 5 4 1 12 0v5C8 6 6 8 6 12h7v14H0V13Zm19 0C19 5 23 1 31 0v5c-4 1-6 3-6 7h7v14H19V13Z" />
            </svg>
            <blockquote className={styles.quote}>{testimonial.quote}</blockquote>
            <figcaption className={styles.author}>
              <span className={styles.avatar} aria-hidden="true">
                <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="3.5" /><path d="M5 21v-2a7 7 0 0 1 14 0v2" /></svg>
              </span>
              {testimonial.author}
            </figcaption>
          </figure>
        ))}
      </div>
    </Section>
  );
}
